enum KeyboardKeyCodeEnum {
	'number0' = '0',
	'number1' = '1',
	'number2' = '2',
	'number3' = '3',
	'number4' = '4',
	'number5' = '5',
	'number6' = '6',
	'number7' = '7',
	'number8' = '8',
	'number9' = '9',
	backspace = 'backspace',
	decimal = 'decimal',
	space = ' ',
	Q = 'Q',
	W = 'W',
	E = 'E',
	R = 'R',
	T = 'T',
	Y = 'Y',
	U = 'U',
	I = 'I',
	O = 'O',
	P = 'P',
	A = 'A',
	S = 'S',
	D = 'D',
	F = 'F',
	G = 'G',
	H = 'H',
	J = 'J',
	K = 'K',
	L = 'L',
	Z = 'Z',
	X = 'X',
	C = 'C',
	V = 'V',
	B = 'B',
	N = 'N',
	M = 'M',
	q = 'q',
	w = 'w',
	e = 'e',
	r = 'r',
	t = 't',
	y = 'y',
	u = 'u',
	i = 'i',
	o = 'o',
	p = 'p',
	a = 'a',
	s = 's',
	d = 'd',
	f = 'f',
	g = 'g',
	h = 'h',
	j = 'j',
	k = 'k',
	l = 'l',
	z = 'z',
	x = 'x',
	c = 'c',
	v = 'v',
	b = 'b',
	n = 'n',
	m = 'm',
	'@' = '@',
	'.' = '.',
	_ = '_',
	'-' = '-',
	'plus' = '+'
}
export default KeyboardKeyCodeEnum;
